import type { RefObject } from 'react';

export default function scrollRefIntoView(ref: RefObject<HTMLElement | null>, options?: ScrollIntoViewOptions) {
  const block = options?.block ?? 'center';
  setTimeout(() => {
    ref.current?.scrollIntoView({
      behavior: 'smooth',
      block,
      ...options,
    });
  }, 200);
}
